module.exports = __webpack_public_path__ + "static/media/hot_stamping.990af4a1.jpg";